import React from 'react';

class Wrapper extends React.Component {
  render() {
    return (
      <div id="adminlte-template-wrapper" className="wrapper" style={{ minHeight: '100vh' }}>
        {this.props.children}
      </div>
    );
  }
}

export default Wrapper;
